module.exports = __webpack_public_path__ + "media/images/front/event/link-icon-a62f99977bd34356c3d90a1fc96b66fd.svg";